import Line from "./Line.js";
import { Bezier } from "bezier-js";

interface Point {
  x: number;
  y: number;
}

class QuadCurve extends Line {
  type: "curve";
  bezier: Point;

  constructor(start: Point, end: Point, bezier: Point | null = null) {
    super({ start, end });
    this.type = "curve";
    this.bezier = {
      x: bezier?.x ?? 0,
      y: bezier?.y ?? 0
    };
  }

  static getLength(line: QuadCurve | Line) {
    if (!(line instanceof QuadCurve)) {
      return super.getLength(line);
    }

    const curve = new Bezier(
      line.start.x,
      line.start.y,
      line.bezier.x,
      line.bezier.y,
      line.end.x,
      line.end.y
    );

    return curve.length();
  }

  moveX(amount: number) {
    this.bezier.x += amount;
    super.moveX(amount);
  }
  moveY(amount: number) {
    this.bezier.y += amount;
    super.moveY(amount);
  }

  get bezierCurve() {
    return new Bezier(
      this.start.x,
      this.start.y,
      this.bezier.x,
      this.bezier.y,
      this.end.x,
      this.end.y
    );
  }

  get length() {
    return this.bezierCurve.length();
  }

  get center() {
    return this.get(0.5);
  }

  get(percent: number) {
    return this.bezierCurve.get(percent);
  }

  get toSVGString() {
    return `Q${this.bezier.x} ${this.bezier.y}, ${this.end.x} ${this.end.y}`;
  }
}

export default QuadCurve;
